import React from "react";
import {
  VerticalTimeline,
  VerticalTimelineElement,
} from "react-vertical-timeline-component";
import "react-vertical-timeline-component/style.min.css";
import axios from "axios";
import { useEffect, useState } from "react";
import { getCookie } from "./getCookies"; // path to your helper
import noDataImage from "./no-data-bg.jpg"; // Adjust the path to your image

import {
  Typography,
  Button,
  Row,
  Col,
  Tag,
  Space,
  Popconfirm,
  Card,
  message,
} from "antd";
import { EditOutlined, DeleteOutlined, PlusOutlined } from "@ant-design/icons";
import { useNavigate } from "react-router-dom";

const { Title, Paragraph } = Typography;

const fakeImpactData = [
  {
    id: 1,
    title: "Publication in Journal",
    date: "Jan 2025",
    description: "Published in Nature on quantum computing in healthcare.",
    indicators: [
      { name: "Articles", value: 3, unit: "count" },
      { name: "Views", value: 10000, unit: "visits" },
    ],
    category: "Scientific",
    status: "pending",
  },
  {
    id: 2,
    title: "Policy Influence",
    date: "Apr 2025",
    description: "Cited in EU Green Deal communication report.",
    indicators: [{ name: "Policies Affected", value: 1, unit: "count" }],
    category: "Societal",
    status: "achieved",
  },
];

// Map status to tag color and label
const statusColors = {
  pending: "orange",
  achieved: "green",
  not_achieved: "red",
};

const ImpactTimelineAntD = ({ steps, onEdit, onDelete, onAddImpact }) => {
  const [kips, setKips] = useState([]);
  const navigate = useNavigate();
  const fetchKIPs = async () => {
    const token = localStorage.getItem("access_token");
    const projectId = localStorage.getItem("project_id");

    try {
      const response = await axios.get(
        `https://eutracker.rdiup.com/v1/api/kips/${projectId}/`,
        {
          headers: {
            Authorization: `Bearer ${token}`, // Include auth if needed
          },
        }
      );
      setKips(response.data);
    } catch (error) {
      console.error("Failed to fetch KIPs", error);
    }
  };
  useEffect(() => {
    fetchKIPs();
  }, []);

  const handleDelete = async (stepId) => {
    try {
      //const csrfToken = getCookie("csrftoken");

      const response = await axios.delete(
        `https://eutracker.rdiup.com/v1/steps/${stepId}/delete/`,
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("access_token")}`,
          },
        }
      );

      if (response.status === 204) {
        message.success("Step deleted");
        setKips((prevKips) =>
          prevKips.map((kip) => ({
            ...kip,
            steps: kip.steps.filter((s) => s.id !== stepId),
          }))
        );
        fetchKIPs();
      }
    } catch (error) {
      console.error("Delete failed", error);
      message.error("Failed to delete step");
    }
  };

  const handleEdit = (step) => {
    navigate(`/impacts/edit/${step}`);
  };

  return (
    <div style={{ padding: 24, background: "#fff", borderRadius: 8 }}>
      <Row justify="space-between" align="middle" style={{ marginBottom: 24 }}>
        <Col>
          <Title level={3}>Impact Pathway</Title>
        </Col>
        <Col>
          <Button
            type="primary"
            icon={<PlusOutlined />}
            onClick={() => navigate("/impactForm")}
          >
            Add Impact Pathway
          </Button>
        </Col>

        <Col>
          <Button type="primary" icon={<PlusOutlined />}>
            Check report{" "}
          </Button>
        </Col>
      </Row>

      <VerticalTimeline>
        {Array.isArray(kips) && kips.length > 0 ? (
          kips.map((kip) =>
            kip.steps.map((step, stepIdx) => (
              <VerticalTimelineElement
                key={`${kip.id}-${stepIdx}`}
                date={step.date}
                iconStyle={{ background: "#1890ff", color: "#fff" }}
                contentStyle={{ boxShadow: "0 0 8px rgba(0, 0, 0, 0.15)" }}
              >
                <Title level={5}>{kip.title}</Title>
                <Paragraph>{step.description}</Paragraph>
                <Paragraph italic>{step.means_of_verification}</Paragraph>
                <Tag color="blue">{kip.category}</Tag>
                <Tag color={statusColors[step.status] || "default"}>
                  {step.status}
                </Tag>
                <ul>
                  {step.indicators?.map((ind, index) => (
                    <li key={index}>
                      {ind.name}: {ind.value} {ind.unit}
                    </li>
                  ))}
                </ul>
                <Space style={{ marginTop: 16 }}>
                  <Button
                    type="default"
                    icon={<EditOutlined />}
                    onClick={() => handleEdit(kip.id)}
                  >
                    Edit
                  </Button>
                  <Popconfirm
                    title="Are you sure to delete this step?"
                    onConfirm={() => handleDelete(kip.id)}
                    okText="Yes"
                    cancelText="No"
                  >
                    <Button danger icon={<DeleteOutlined />}>
                      Delete
                    </Button>
                  </Popconfirm>
                </Space>
              </VerticalTimelineElement>
            ))
          )
        ) : (
          <Card
            style={{
              margin: 24,
              textAlign: "center",
              backgroundImage: `url(${noDataImage})`, // Use your imported image
              backgroundSize: "cover", // Cover the entire card area
              backgroundPosition: "center", // Center the image
              minHeight: 200, // Give it some height so the background is visible
              display: "flex",
              flexDirection: "column",
              justifyContent: "center",
              alignItems: "center",
              color: "#fff", // White text for better contrast on a dark background
              textShadow: "1px 1px 3px rgba(0,0,0,0.7)", // Add a subtle text shadow
            }}
            bodyStyle={{ padding: 24 }} // Adjust padding for the Card body
          >
            <Title level={4} style={{ color: "inherit" }}>
              No data available
            </Title>
            <p style={{ color: "inherit", marginTop: 8 }}>
              It looks like there's nothing to display here yet.
            </p>
          </Card>
        )}
      </VerticalTimeline>
    </div>
  );
};

export default ImpactTimelineAntD;
